import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tableRowSkeleton: {
    display: 'grid',
    gridTemplateColumns: '8fr 40fr 8fr 8fr 8fr 8fr 1fr',
    height: 100,
    alignItems: 'center',
    width: '100%',
    textAlign: 'unset',
    [theme.breakpoints.down(768)]: {
      gridTemplateColumns: '1.1fr 1.1fr 0.1fr'
    }
  },
  skeleton: {
    width: '80%',
    marginLeft: 8
  },
  moreIconHidden: {
    opacity: 0
  }
}))

export default useStyles
